import { render, staticRenderFns } from "./features-history-page.vue?vue&type=template&id=6c0a2a06&scoped=true&"
import script from "./features-history-page.vue?vue&type=script&lang=js&"
export * from "./features-history-page.vue?vue&type=script&lang=js&"
import style0 from "./features-history-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./features-history-page.vue?vue&type=style&index=1&id=6c0a2a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a2a06",
  null
  
)

export default component.exports